import {
  FeatureFlagConfig,
  FeatureManagementSource
} from 'v5/services/front/FeatureManagementService/types';
import { FeatureManagementActionHandler } from 'v5/services/front/FeatureManagementService/FeatureManagementService';
import { maybe } from '@passionware/monads';

export function configSupportsBulk(config: FeatureFlagConfig): boolean {
  if (!config.supported) {
    return false;
  }
  return config.value.type === 'boolean' || config.value.type === 'enum';
}

export function getEffectiveBooleanValue(
  config: FeatureFlagConfig
): boolean | null {
  if (!config.supported || config.value.type !== 'boolean') {
    return null;
  }
  return (
    maybe.getOrElse(config.value.current, config.value.defaultValue) === true
  );
}

export function applyBulkCellValue(
  onAction: FeatureManagementActionHandler,
  source: FeatureManagementSource,
  featureId: string,
  config: FeatureFlagConfig,
  enabled: boolean
): void {
  if (!config.supported) {
    return;
  }

  if (config.value.type === 'boolean') {
    if (config.optional && !enabled) {
      onAction({ type: 'clearFeatureFlag', source, featureId });
      return;
    }
    onAction({ type: 'setFeatureFlag', source, featureId, value: enabled });
    return;
  }

  if (!config.optional) {
    return;
  }

  if (!enabled) {
    onAction({ type: 'clearFeatureFlag', source, featureId });
    return;
  }

  const nextValue =
    config.value.options.find(option => option !== 'none') ??
    config.value.options[0];
  onAction({ type: 'setFeatureFlag', source, featureId, value: nextValue });
}
